// React
import React from 'react';

// Styles
import styles from './NotFound.module.scss';
import { ReactComponent as Logo } from '../../../images/logo-black.svg';
import { Typography } from '@material-ui/core';


// This component
export default function NotFound() {
  // Session Context
  
  return (
    
    <div className={styles.wrapper}>
      <div className={styles.box}>
        <header className={styles.header}>
          <Logo className={styles.logo} />
        </header>

        <main className={styles.main}>
          <Typography variant="h2" component="h1" className={styles.title}>
            The page you are looking for does not exist
          </Typography>

          
        </main>
      </div>
    </div> 

  )

}
